import { Component, input } from '@angular/core';
import { LegalTextData, LegalTextLink } from '@core/models';

@Component({
  standalone: true,
  selector: 'app-legal-terms',
  templateUrl: './legal-terms.component.html',
  styleUrls: ['./legal-terms.component.css'],
})
export class LegalTermsComponent {
  public legalTextData = input.required<LegalTextData>();
  private textWithBracketsRegex = /(\{.+?\})/;
  private textWithinBracketsRegex = /\{(.+?)\}/;

  protected parseText(text: string): (string | LegalTextLink)[] {
    const textParts: (string | LegalTextLink)[] = [];
    const splitText = text.split(this.textWithBracketsRegex);

    for (const part of splitText) {
      const textWithinBrackets = part.match(this.textWithinBracketsRegex)?.[1];
      // @ts-ignore
      const linkData = this.legalTextData().links?.[textWithinBrackets];

      if (textWithinBrackets && linkData) {
        if (this.legalTextData().links?.[textWithinBrackets]) {
          textParts.push(linkData);
        }
      } else {
        textParts.push(part);
      }
    }

    return textParts;
  }

  protected isLink(part: string | LegalTextLink): part is LegalTextLink {
    return typeof part !== 'string';
  }
}
